module.exports = __webpack_public_path__ + "static/img/6333_phase_function_Paper_PointsHejduk_Prediction.63bf8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6333_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ZR8V
// module chunks = 0